import React from 'react';
import styled from 'styled-components';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import moment from "moment";


const EsReqRefundInfoBlock = styled.div`
    color: #333333;
    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        margin-bottom: 20px;
    }

    .sub-title1 {
        font-size: 13px;
        font-weight: 500;
        line-height: 1.69;
        color: #333333;
        margin-bottom: 10px;
    }

    .sub-title2 {
        font-size: 13px;
        font-weight: normal;
        line-height: 1.69;
        color: #333333;
        margin-bottom: 10px;
    }

    .sub-num {
        font-size: 12px;
        font-weight: normal;
        line-height: 1.67;
        color: #666666;
        //margin-bottom: 5px;

        .num {
            font-weight: 500;
        }
    }

    .sub-gray {
        font-size: 12px;
        font-weight: normal;
        line-height: 1.67;
        color: #cccccc;
    }

    .margin-text {
        margin-bottom: 20px;
        width: 100%;
    }
    
`;

const EsReqRefundInfo = ({ detailInfo }) => {

    if(detailInfo === null || detailInfo === undefined) {
        return <div/>
    }

    return (
        <EsReqRefundInfoBlock>
            <div className="title ">반품/교환 안내</div>
            <div className="sub-title1 ">* 반품/교환 사유로 요청 가능 기간</div>
            <div className="sub-title2 ">반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.</div>
            <div className="sub-num "><span className="num">1</span>. 구매자 단순 변심은 상품 수령 후 <span className="num">7</span>일 이내</div>
            <div className="sub-gray ">(구매자 반품배송비 부담)</div>
            <div className="sub-num "><span className="num">2</span>. 표시/광고와 상이, 상품하자의 경우 상품 수령 후 <span className="num">3</span>개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 <span className="num">30</span>일 이내. 둘 중 하나 경과 시 반품/교환 불가</div>
            <div className="sub-gray margin_b-30">(판매자 반품배송비 부담)</div>

            <div className="sub-title1 ">* 반품/교환 불가능한 사유</div>
            <div className="sub-title2 ">아래와 같은 경우 반품/교환이 불가능합니다.</div>
            <div className="sub-num "><span className="num">1</span>. 반품요청기간이 지난 경우</div>
            <div className="sub-num "><span className="num">2</span>. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우</div>
            <div className="sub-gray ">(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</div>
            <div className="sub-num "><span className="num">3</span>. 포장을 개봉하였으나 포장이 훼손되어 상품가치가 현저히 상실된 경우</div>
            <div className="sub-gray ">(예: 식품, 화장품)</div>
            <div className="sub-num "><span className="num">4</span>. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우</div>
            <div className="sub-gray ">(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</div>
            <div className="sub-num "><span className="num">5</span>. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우</div>
            <div className="sub-gray ">(예: 식품, 화장품)</div>
            <div className="sub-num "><span className="num">6</span>. 고객주문 확인 후 상품제작에 들어가는 주문제작상품</div>
            <div className="sub-num "><span className="num">7</span>. 복제가 가능한 상품 등의 포장을 훼손한 경우</div>
            <div className="sub-gray ">(CD/DVD/GAME/도서의 경우 포장 개봉 시)</div>

        </EsReqRefundInfoBlock>
    );
};

export default EsReqRefundInfo;
